<template>
    <div v-if="result.answers">
        <ProductReviewItem :result="result" :messages="messages" :user="user" @openReviewModal="(data) => $emit('openReviewModal', data)"/>
        <ProductReview v-for="(answer, key) in result.answers" :key="key" :result="answer" :messages="messages" :user="user" @openReviewModal="(data) => $emit('openReviewModal', data)"/>
    </div>
    <div v-else>
        <ProductReviewItem :result="result" :messages="messages" :user="user" @openReviewModal="(data) => $emit('openReviewModal', data)"/>
    </div>
</template>

<script>
    import ProductReviewItem from "./ProductReviewItem.vue";

    export default {
        name: "ProductReview",
      components: {ProductReviewItem},
        selector: '.product-review',
        props: ['result', 'messages', 'user']
    }
</script>

<style lang="scss" scoped>
    .product-review {
    }
</style>